
import { defineComponent, onMounted, toRefs } from 'vue';
import { overlayComposition } from '@/core/modules/overlay/services';
import { modIndicatorComposition } from '../services';

import { analyticsClickTrack } from '@/core/modules/analytics/services/analytics.click.track';

export default defineComponent({
	props: {
		datum: {
			type: Array,
			required: true,
		},
		ready: {
			type: Boolean,
			default: false,
		}
	},
    setup(props) {
		const { datum } = toRefs(props);

		onMounted(() => {
			analyticsClickTrack();
		});

        return {
            ...overlayComposition(),
			...modIndicatorComposition(datum)
        }
    }
})
